<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-11 10:42:40
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-08-18 14:23:06
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/attachmentUpload.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 附件上传 -->
<template>
  <div>
    <div class="tip-message">
      <p>
        1、上传协议即代表您已经同意了所有协议条款，请彩色打印协议，确保所有内容条款均已填写。
      </p>
      <p>
        2、首页填上传协议当日日期，签字页法人签章需工整、清晰，加盖骑缝章后彩色扫描上传。
      </p>
      <p>
        3、若非法人代表签字，则需要有法人代表授权书，并与合同一起扫描并上传。
      </p>
    </div>
    <div class="download-agreement-file">
      请下载
      <eui-btn type="link" @click="downloadAgreement"
        >产品质量评价委托协议</eui-btn
      >并盖章上传
    </div>
    <div class="upload-wrap">
      <fileUpload
        :limit="1"
        :fileSize="50"
        :uploadUrl="uploadUrl"
        :verify="true"
        @getFileInfo="getFileInfo"
        :tipsMessage="tipsMessage"
        :uploadImage="true"
        :url="url"
      ></fileUpload>
    </div>
  </div>
</template>

<script>
import fileUpload from '../../../../components/common/e-upload.vue';
import api from '../../../../api/evaluation/index';
import utils from '../../../../utils/utils';
export default {
  props: {
    url: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      uploadUrl: '',
      tipsMessage: '提示：仅支持PDF格式的文件，最多可上传1个，大小小于50M'
    };
  },

  components: { fileUpload },

  computed: {},

  created() {
    this.uploadUrl = api.uploadCommissionAttachment;
    console.log(this.uploadUrl, 'this.uploadUrl');
  },
  methods: {
    getFileInfo(options) {
      console.log(options);
      this.$emit('getUploadFileList', options);
    },
    async downloadAgreement() {
      let res = await api.downloadEvaluationCommission();
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '产品质量评价委托协议', '.pdf');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tip-message {
  padding: 15px 10px;
  background: #f4f7ff;
  font-size: 0;
  p {
    line-height: 14px;
    color: #666;
    font-size: 14px;
  }
  p:not(:last-child) {
    margin-bottom: 4px;
  }
}
.download-agreement-file {
  font-size: 14px;
  color: #333;
  margin-top: 12px;
}
.upload-wrap {
  margin-top: 12px;
}
</style>
